import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
    interface Window {
        utag?: {
        data: any;
        view: (data: Record<string, any>) => void;
        };
    }
}

const TealiumTrackingWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    let retries = 0;
    const maxRetries = 10;
    const retryInterval = 300; // ms

    const sendTealiumView = () => {
      if (window.utag && typeof window.utag.view === "function") {
        const data = {
          tealium_event: "view",
          site_name: "645574",
          page_name: location.pathname,
          page_url: window.location.href,
          language: navigator.language || "es",
        };
    
        window.utag.data = {
          ...window.utag.data,
          ...data 
        };
        window.utag.view(window.utag.data);
        
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(sendTealiumView, retryInterval);
      } else {
        console.warn("Tealium no disponible después de varios intentos.");
      }
    };
    sendTealiumView();
  }, [location]);

  return null;
};

export default TealiumTrackingWrapper;